import { Typography } from '@material-ui/core'
import _ from 'lodash'
import moment from 'moment'
import React from 'react'
import styled from 'styled-components'

type Props = {
  title: string
  color: string
  labels: string[]
}

export function timeLabel(ts: number | undefined): string {
  if (!ts) return ''
  return moment(ts).format('HH:mm:ss')
}

const CompTimeHeader = ({ labels, title, color }: Props) => {
  return (
    <Style>
      <div className="title-cell">
        <Typography>{title}</Typography>
      </div>
      <div className="times">
        {_.range(1, 12).map(i => {
          if (!labels[i]) return <div key={i} className="cell" />

          return (
            <div key={i} className="cell">
              <Typography style={{ color }}>{labels[i]}</Typography>
            </div>
          )
        })}
      </div>
    </Style>
  )
}

const Style = styled.div`
  display: grid;
  grid-template-columns: 2fr 10fr;
  height: 44px;

  .title-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .times {
    display: grid;
    grid-template-columns: repeat(11, 1fr);
    height: 100%;
  }

  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  p {
    text-align: center;
  }
`

export default CompTimeHeader
